import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { ExercicesProvider } from '../providers/exercices-provider';
import { Exercice } from "../../common/models/exercice";
import { Feedback } from "../../common/models/feedback";
import { Observable } from "rxjs";

@Injectable({providedIn: 'root'})
export class ExerciseResolverService implements Resolve<Feedback> {
    constructor(
        private exerciseProvider: ExercicesProvider
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.exerciseProvider.findOneById(+route.params['exerciseId']);
    }
}
